// Dispute Workflow Reducer
import { actionTypes } from "./actions";

const initialState = {
  allWorkflows: [], // Full list across all pages, used by workflow selectors
  workflowSteps: {
    data: [], // Empty initial state - will be populated from backend
    isFetching: false,
    page: 1,
    pages: 1,
    total: 0,
    has_next: false,
    has_prev: false,
  },
  selectedWorkflow: null,
  bulkAssignment: {
    selectedSequence: "",
    overrideAssignment: false,
    futureDisputeWorkflowSequenceId: "",
  },
};

const disputeWorkflowReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DISPUTE_WORKFLOW_STEPS:
      return {
        ...state,
        workflowSteps: {
          data: action.payload.data,
          isFetching: false,
          page: action.payload.page,
          pages: action.payload.pages,
          total: action.payload.total,
          has_next: action.payload.has_next,
          has_prev: action.payload.has_prev,
        },
      };

    case actionTypes.SET_ALL_DISPUTE_WORKFLOWS:
      return {
        ...state,
        allWorkflows: action.payload,
      };

    case actionTypes.SET_DISPUTE_WORKFLOW_FETCHING:
      return {
        ...state,
        workflowSteps: {
          ...state.workflowSteps,
          isFetching: action.payload,
        },
      };

    case actionTypes.CREATE_DISPUTE_WORKFLOW:
      return {
        ...state,
        workflowSteps: {
          ...state.workflowSteps,
          data: [action.payload, ...state.workflowSteps.data],
        },
      };

    case actionTypes.UPDATE_DISPUTE_WORKFLOW:
      return {
        ...state,
        workflowSteps: {
          ...state.workflowSteps,
          data: state.workflowSteps.data.map((workflow) =>
            workflow.id === action.payload.id
              ? { ...workflow, ...action.payload.data }
              : workflow
          ),
        },
      };

    case actionTypes.DELETE_DISPUTE_WORKFLOW:
      return {
        ...state,
        workflowSteps: {
          ...state.workflowSteps,
          data: state.workflowSteps.data.filter(
            (workflow) => workflow.id !== action.payload
          ),
        },
      };

    case actionTypes.ASSIGN_DISPUTE_WORKFLOW:
      return {
        ...state,
        bulkAssignment: {
          ...state.bulkAssignment,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};

export default disputeWorkflowReducer;
